module.exports = __webpack_public_path__ + "static/media/aboutBackground_right.cf1630e1.svg";